module.exports = __webpack_public_path__ + "img/victorious-mobile-total.09031583.jpg";